import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from '../Contexts/AppContext'; 
import { toggleMiniCart } from "./SideCart";
import Constants from "../Utilities/Constants";
import Cookies from "js-cookie";
import GetCustomer from "./GetCustomer";
import axios from "axios";


const Header = () => {
    const { customer } = useAppContext();

    return (
        <header>
            <TopMenu />
            <HeaderMain />
            <NavBar business={customer && customer.business} customer={customer}/>
        </header>
    )
}


const TopMenu = () => {
    const [topLeftMenu, setTopLeftMenu] = useState([])
    const [topRightMenu, setTopRightMenu] = useState([])    

    useEffect(() => {
        
        async function getMenu (name) {
            const url = `${Constants.API_URL_GET_MENU}/${name}`;
            var menu;

            await fetch(url, { headers: { 'X-Api-Key': Constants.API_KEY } })
                .then(response => response.json())
                .then(data => menu=data);

            return menu;
        }

        (async () => {
            setTopLeftMenu(await getMenu("תפריט עליון שמאל"));
            setTopRightMenu(await getMenu("תפריט עליון ימין"));
        })();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <div className="d-flex justify-content-between header-top">

            <div className="d-flex m-2">
            {topRightMenu &&
                topRightMenu.map((item, index) => (
                    <div key={index}> {/* Add key and wrap in div */}
                        <Link to={{pathname:`${item.link}`}}>{item.title}</Link>
                        { index < topRightMenu.length - 1 ?
                            <span><svg height="10" width="10" xmlns="http://www.w3.org/2000/svg"><circle r="22" cx="10" cy="0" fill="green" /></svg></span>
                            : <></>
                        }
                    </div>
                ))
            }
            </div>
            <div className="d-flex m-2">
            {topLeftMenu &&
                topLeftMenu.map((item, index) => (
                    <div key={index}> {/* Add key and wrap in div */}
                        <Link to={{pathname:`${item.link}`}}>{item.title}</Link>
                        { index < topLeftMenu.length - 1 ?
                            <span><svg height="10" width="10" xmlns="http://www.w3.org/2000/svg"><circle r="22" cx="10" cy="0" fill="green" /></svg></span>
                            : <></>
                        }
                    </div>
                ))
            }
            </div>
        </div>
    )
}

const HeaderMain = () => {
    // Get everything from the combined context
    const { site, customer, setCustomer, setCart, setCartId, enrichProduct, cart, setShowLoginModal } = useAppContext();
    const [ searchResults, setSearchResults ] = useState([]);
    const [query, setQuery] = useState();
    const navigate = useNavigate();

    const Search = async (str) => {
        if (str.length < 2) {
            setSearchResults([]);
            setQuery('');
        }
        else {
            setQuery(str);
            const url = `${Constants.API_URL_GET_PRODUCTS}/${str}`;
            const response = await axios.get(url);	
            
            setSearchResults(response.data);
        }
    }

    async function logoff () {
        Cookies.remove('customerid',customer.id);
        GetCustomer({setCustomer, setCart, setCartId, enrichProduct}); // Use enrichProduct
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (query && query.trim()) {
            setSearchResults([]);
            setQuery('');
            
            const searchInput = document.getElementById('searchInputDesktop');
            searchInput.value = '';
            
            navigate(`/Search/${encodeURIComponent(query.trim())}`);
        }
    }

    const handleProductClick = () => {
        setSearchResults([]);
        setQuery('');
        const searchInput = document.getElementById('searchInputDesktop');
        if (searchInput) {
            searchInput.value = '';
        }
    }

    const handleSearchInputChange = (e) => {
        const value = e.target.value;
        Search(value);
    }

    return (
        <div className="d-flex justify-content-between align-items-center header-middle position-relative">
        <div className="headerRight"></div>

        <div className="d-flex justify-content-center flex-grow-1">

            <div className="menuitem">
                <form name="formSearchDesktop" className="form-inline headerSearchFront" onSubmit={handleSubmit} method="post">
                    <div>
                        <input 
                            type="text" 
                            placeholder="חפש מוצר" 
                            id="searchInputDesktop" 
                            name="searchText" 
                            autoComplete="off" 
                            className="searchText" 
                            onChange={handleSearchInputChange}
                        />
                        <SearchList list={searchResults} onProductClick={handleProductClick}/>
                    </div>
                    <input type="submit" className="left headerSearchSubmit" value="" />
                </form>
            </div>

        </div>
        <div className="headerLeft d-flex align-item-center">
            
            <div className="topMenu d-flex align-items-center p-2">
                {customer ? 
                <>
                <div className="m-1">
                {customer.picture ? 
                    <img className="rounded user-picture" src={customer.picture} alt={customer.customerName} referrerPolicy="no-referrer"/>
                    :
                    <>
                    <svg width="24" height="24" viewBox="0 0 16 16" className="bi bi-person-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                    </svg>
                    <span className="m-1">{customer.customerName}</span>
                    </>
                }
                </div>
                <Link className="btn btn-success float-start mx-2" to="/Profile">אזור אישי</Link>
                <button className="btn btn-outline-secondary float-start mx-2" onClick={logoff} >התנתק</button>
                </>
                : 
                <>
                <button className="btn btn-primary mx-2" onClick={() => setShowLoginModal(true)}>כניסה לחשבון</button>
                </>
                }

            </div>
            <button className="cart-icon p-0 border-0" onClick={toggleMiniCart} >
                <div className="totals">
                    { cart && cart.length > 0 && (
                    <div id="showcart" className="TotalPrice">סה"כ <span>{cart.reduce((a, v) => a + v.itemTotal, 0).toFixed(2)}</span></div>
                    )}
                    <div className="fly-to position-relative">
                        <svg width="32" height="32" viewBox="0 0 16 16" className="bi bi-cart3" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l.84 4.479 9.144-.459L13.89 4H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path>
                        </svg>
                        <div id="TotalItems">{cart.length || ''}</div>
                    </div>
                </div>
            </button>
        </div>
        
        {/* {logo &&  */}
        <div className="logo position-absolute px-3">
            <Link to="/"> <img src={`${Constants.IMAGE_URL}${site?.logo}`} alt="Logo" /></Link>
        </div>
        {/* } */}
        </div>
    )

}

const SearchList = ({list, onProductClick}) => {
    return (
        <>
        {list && list.length > 0 &&
        <div className="search-dropdown">
            <div className="search-results-grid">
                {list.map((item) => (
                    <Link 
                        to={`/Product/${item.productUrl}`}
                        key={item.productUrl}
                        className="search-result-item"
                        onClick={onProductClick}
                    >
                        <div className="search-item-image">
                            <img src={`${Constants.IMAGE_URL}${item.image}`} alt={item.productName} />
                        </div>
                        <div className="search-item-text">
                            <span className="product-name">{item.productName}</span>
                            {item.price && <span className="product-price">₪{item.price}</span>}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
        }
        </>
    )
}

const NavBar = ({business, customer}) => {
    const [categories, setCategories] = useState([])

    useEffect(() => {
        
        async function getCategories () {
            const url = Constants.API_URL_GET_CATEGORIES;
            var api = url;
    
            if (business) {
                api = `${url}?b=true`;
            }
    
            await fetch(api, { headers: { 'X-Api-Key': Constants.API_KEY } })
                .then(response => response.json())
                .then(data => setCategories(data));
        }

        getCategories();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business])

    // Flip dropdowns that would overflow the left edge of the viewport
    useEffect(() => {
        if (!categories.length) return;

        const handleMouseEnter = function() {
            const drop = this.querySelector('.menu_drop');
            if (!drop) return;
            const rect = this.getBoundingClientRect();
            const dropWidth = 330; // matches CSS min-width
            if (rect.right + 20 - dropWidth < 0) {
                drop.style.right = 'auto';
                drop.style.left = '-10px';
            } else {
                drop.style.right = '';
                drop.style.left = '';
            }
        };

        const items = document.querySelectorAll('.mega-menu > div');
        items.forEach(item => item.addEventListener('mouseenter', handleMouseEnter));
        return () => items.forEach(item => item.removeEventListener('mouseenter', handleMouseEnter));
    }, [categories]);


    return (
        <div className="d-flex bg-gradient box-shadow header">
            <div className="headerRight"></div>
            <div className="mega-menu">
                <div>
                    <Link className="nav-sale" to={{pathname:`/Category/sale`}}>מבצעי השבוע</Link>
                </div>
                {customer &&
                <div>
                    <Link className="nav-sale" to={{pathname:`/Category/MyProducts`}}>המוצרים שלי</Link>
                </div>
                }
            {
                categories.map((item, index) => (
                    <div key={index}>
                        <Link to={{pathname:`/Category/${item.categoryUrl}`}}>{item.categoryName}</Link>
                        <div className="menu_drop" >
                            <div >
                            {
                                item.subCategories.map((node, idx) => (
                                    <div className="drop_col" key={idx}>
                                        <div className="drop_link">
                                            <Link className="dropdown-item" to={{pathname:`/Category/${item.categoryUrl}/${node.subCategoryUrl}`}}>{node.subCategoryName}</Link>
                                        </div>
                                    </div>
                                ))
                            }
                            </div>
                        </div>
                </div>
                ))
            }

            </div>
        </div>
    )
}


export default Header;
